import { render, staticRenderFns } from "./FormControlProperties.vue?vue&type=template&id=47dd8878&scoped=true&"
import script from "./FormControlProperties.vue?vue&type=script&lang=ts&"
export * from "./FormControlProperties.vue?vue&type=script&lang=ts&"
import style0 from "./FormControlProperties.vue?vue&type=style&index=0&id=47dd8878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dd8878",
  null
  
)

export default component.exports